<!-- components/events/yuka/Apply.svelte -->
<script>
  import { createEventDispatcher } from 'svelte';
  const dispatch = createEventDispatcher();
  const applySrc = `assets/img/yukaEvent/apply.png`;

  function handleClick(event) {
    event.preventDefault();  // 防止連結轉跳
    dispatch('applyClicked', event.currentTarget.href);  // 呼叫上層applyClicked,並夾帶網址
  }
</script>


<!-- ======= Apply Section ======= -->
<section class="yuka-apply">
  <div class="container">
    <div class="row content">
      <div class="d-flex align-items-center justify-content-center">
        <div class="col-sm-12 col-md-6 col-lg-3 yuka-apply-img-center">
          <a href={'https://buy.stripe.com/4gwaFN0yfa7Vb2EfZ4'} target="_blank" class="download-link" on:click={handleClick}>
            <img src={applySrc} class="img-fluid download-icon" alt="">
          </a>
        </div>
      </div>
    </div>
  </div>
</section><!-- End Apply Section -->